import { Component, ViewEncapsulation, Input } from "@angular/core";
import * as Highcharts from "highcharts";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { RatingDistribution } from "../../interfaces";
import { ConsensusSummaryDataService } from "../../consensus-summary-data.service";
import { AppService } from "src/app/app.service";
import { TPR_LOG_ACTION_FEATURES, TPR_PAGE } from "src/app/tpr/tpr-constants";
@Component({
  selector: "app-rating-distribution",
  templateUrl: "./rating-distribution.component.html",
  styleUrls: ["./rating-distribution.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class RatingDistributionComponent {
  faInfoCircle = faInfoCircle;
  @Input() ratingDistribution: any;
  @Input() hasConsensus: boolean;
  @Input() totalBrokers: number;
  @Input() brokerInRatingConsensus: number;
  @Input() sumOfBrokerWithBuyHoldSellRating: number;
  @Input() tprConsensusDataReady: boolean;
  @Input() primaryTicker: string;
  data: RatingDistribution[] = [];
  highcharts = Highcharts;
  chartOptions: any;

  constructor(
    private dataService: ConsensusSummaryDataService,
    private appService: AppService,
  ) {
    this.dataService.setSelectedConsensusDistribution(-1);
  }

  ngOnChanges(changes) {
    if (
      changes.ratingDistribution.currentValue !==
      changes.ratingDistribution.previousValue
    ) {
      this.createRatingDistributionChart();
    }
  }

  createRatingDistributionChart() {
    this.dataService.setSelectedConsensusDistribution(-1);
    const d = this.ratingDistribution || [];
    this.data = d.filter((x) => x.y > 0);
    this.chartOptions = {
      chart: {
        height: 220,
        width: 380,
        margin: [8, 8, 8, -140],
        backgroundColor: null,
        spacingTop: 0,
        spacingBottom: 0,
        spacingLeft: 0,
        spacingRight: 0,
        plotBorderWidth: null,
        plotShadow: false,
      },
      lang: { noData: undefined },
      exporting: { enabled: false },
      credits: { enabled: false },

      title: {
        text: "",
        style: { display: "none" },
      },
      subtitle: {
        text: "",
        style: { display: "none" },
      },
      tooltip: {
        pointFormat: "",
        valueDecimals: 2,
        valueSuffix: "%",
      },

      plotOptions: {
        pie: {
          shadow: false,
          size: 140,
          fillColor: "#E9EBEE",
          allowPointSelect: true,
          states: {
            hover: {
              brightness: 0,
              halo: {
                size: 10,
                opacity: 0.5,
              },
            },
          },
          dataLabels: {
            enabled: false,
          },
          point: {
            events: {
              click: (event) => {
                const reselect = event.point.selected;
                if (reselect) {
                  event.point.series.data.forEach(function (data) {
                    data.update({ opacity: 1 }, false);
                    data.legendItem.css({ opacity: 1 });
                  });
                  this.dataService.setSelectedConsensusDistribution(-1);
                } else {
                  this.dataService.setSelectedConsensusDistribution(
                    event.point.id,
                  );
                  this.appService.logUserAction(
                    {},
                    this.primaryTicker,
                    "",
                    TPR_LOG_ACTION_FEATURES.companyPieSelection,
                    {
                      selected_pie: event.point.name,
                    },
                    "",
                    TPR_PAGE,
                  );
                }
              },
              legendItemClick: (event) => {
                const chartData = event.target;
                const points = chartData.series.points;
                const len = points.length;
                let sletectedDataId = -1;
                const isPieSiced = chartData.sliced;
                chartData.haloPath({
                  size: 0,
                  opacity: 0,
                });
                for (let i = 0; i < len; i++) {
                  const item = points[i];
                  if (!item.sliced && chartData.index === i) {
                    item.update(
                      {
                        selected: true,
                        sliced: true,
                        opacity: 1,
                        state: "select",
                      },
                      false,
                    );
                    item.legendItem.css({ opacity: 1 });
                    if (item.series && item.series.halo) {
                      item.series.halo.hide();
                    }
                    sletectedDataId = chartData.id;
                  } else {
                    if (isPieSiced) {
                      item.update(
                        {
                          selected: false,
                          sliced: false,
                          opacity: 1,
                          state: "",
                        },
                        false,
                      );
                      item.legendItem.css({ opacity: 1 });
                    } else {
                      item.update(
                        {
                          selected: false,
                          sliced: false,
                          opacity: 0.3,
                          state: "",
                        },
                        false,
                      );
                      item.legendItem.css({ opacity: 0.3 });
                    }
                  }
                }
                this.dataService.setSelectedConsensusDistribution(
                  sletectedDataId,
                );
                chartData.series.chart.redraw();
                return false;
              },
              select: function () {
                this.series.data.forEach((data) => {
                  if (this.id !== data.id) {
                    data.update({ opacity: 0.3 }, false);
                    data.legendItem.css({ opacity: 0.3 });
                  } else {
                    data.update({ opacity: 1 }, false);
                    data.legendItem.css({ opacity: 1 });
                  }
                });
                this.series.chart.redraw();
              },
            },
          },
        },
      },
      series: [
        {
          type: "pie",
          borderColor: "transparent",
          data: this.data,
          slicedOffset: 16,
          showInLegend: true,
        },
      ],
      legend: {
        layout: "vertical",
        align: "right",
        verticalAlign: "middle",
        itemMarginTop: 8,
        itemMarginBottom: 8,
        symbolRadius: 0,
        labelFormatter: function () {
          return `<div>${this.name}&nbsp;&nbsp;&nbsp;&nbsp;${
            this.name !== "Hold" ? "&nbsp;&nbsp;" : ""
          }${this.y}&nbsp;(${this.percent})</div>`;
        },
      },
    };
  }
}
